import { SimpleDialog } from 'components';
import { Grid, Button } from '@mui/material';
import { Messages } from 'utility/TextMessages';

const ExportMessageDg = (props) => {
  const { isOpenExportDG, setIsOpenExportDG, message } = props;
  const titles = {
    MESSAGE_REQUEST_BANKI: 'درخواست وضعیت',
    MESSAGE_SHOW_STATUS_REQUEST_BANKI: 'مشاهده وضعیت',
  };
  return (
    <SimpleDialog fullWidth maxWidth="sm" open={isOpenExportDG} title={titles[message]}>
      <Grid container style={{ textAlign: 'justify' }}>
        <div>{Messages[message]}</div>
      </Grid>
      <Grid style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse'}}>
        <Button
          variant="contained"
          onClick={() => setIsOpenExportDG(false)}
        >
          بستن
        </Button>
      </Grid>
    </SimpleDialog>
  );
};

export default ExportMessageDg;
